import React from 'react';

import { GetStarted } from '../components/Onboarding/GetStarted.component';

export const InviteAcceptSuccess: React.FC = () => {
  return <GetStarted />;
};
